import axios from "axios";
import { setLastRequest, setUserData } from "../store/slice/usageInfoSlice";
import { store } from "../store/store";
import authService from "./auth/auth.service";
import { LOCAL_KEYS } from "./GroupContext";

// Common request helper to reduce duplication
const makeRequest = async (method, url, options = {}) => {
  try {
    const user = store.getState().usageInfo.user;
    const headers = {
      Authorization: `Bearer ${user?.id_token}`,
      ...options.extraHeaders,
    };

    let axiosConfig = {
      headers,
      withCredentials: true,
      ...options.config,
    };

    let response = {};
    if (method === "get") {
      response = await axios.get(url, axiosConfig);
    } else if (method === "post" || method === "patch") {
      response = await axios[method](url, options.body, axiosConfig);
    } else if (method === "delete") {
      response = await axios.delete(url, {
        ...axiosConfig,
        data: options.body,
      });
    }

    const { data } = response;
    store.dispatch(setLastRequest(Date.now()));

    // Handle scope update for GET requests
    if (options.handleScope && data?.hasOwnProperty("scope")) {
      const user = store.getState().usageInfo.user;
      user.scope = data?.scope;
      store.dispatch(setUserData(user));
    }

    return { status: 200, data: data?.data ?? null };
  } catch (err) {
    console.error(err);

    if (err?.response?.status === 401) {
      triggerLogin();
      return { status: 400, err: "User is not authenticated" };
    }

    if (options.handleReadonly && err?.response?.status === 403) {
      // could not get a group lock - set readonly to true
      localStorage.setItem(LOCAL_KEYS.userReadonly, true);
      return { status: 400, err: err?.response?.data };
    }

    return {
      status: err?.response?.status ?? 400,
      err: err?.response?.data,
    };
  }
};

const isResponseFailed = (res) => {
  return parseInt(String(res?.status)?.slice(0, 2)) !== 20;
};

const GET = async (
  url,
  params,
  isReadOnly = false,
  requestConfig = {},
  checkStatus = false,
) => {
  const res = await makeRequest("get", url, {
    extraHeaders: {
      "x-readonly-mode": isReadOnly ? "true" : "false",
    },
    config: {
      ...requestConfig,
      params,
    },
    handleScope: true,
  });
  if (checkStatus && isResponseFailed(res)) {
    throw new Error("GET REQ ERROR:", res.err);
  }
  return res;
};

const POST = async (url, body, type, checkStatus = false) => {
  const res = await makeRequest("post", url, {
    body,
    extraHeaders: {
      "Content-Type": type || "application/json",
    },
    handleReadonly: true,
  });
  if (checkStatus && isResponseFailed(res)) {
    throw new Error("POST REQ ERROR:", res.err);
  }
  return res;
};

const PATCH = async (url, body, type, checkStatus = false) => {
  const res = await makeRequest("patch", url, {
    body,
    extraHeaders: {
      "Content-Type": type || "application/json",
    },
    handleReadonly: true,
  });
  if (checkStatus && isResponseFailed(res)) {
    throw new Error("PATCH REQ ERROR:", res.err);
  }
  return res;
};

const DELETE = async (url, body, type, checkStatus = false) => {
  const res = await makeRequest("delete", url, {
    body,
    extraHeaders: {
      "Content-Type": type || "application/json",
    },
    handleReadonly: true,
  });
  if (checkStatus && isResponseFailed(res)) {
    throw new Error("DELETE REQ ERROR:", res.err);
  }
  return res;
};

const triggerLogin = () => {
  authService
    ?.login()
    .then((data) => {
      window.location.href = data;
    })
    .catch((error) => {
      console.log(error);
    });
};

export { DELETE, GET, PATCH, POST };

